import { Link } from "react-router-dom";

const Td = ({ data }) => {
  return (
    <td
      className={
        data.status === 1
          ? "left success"
          : data.status === 0
          ? "left error"
          : data.status === 2
          ? "left working"
          : data.status === 4 || data.status === 5
          ? "left notice"
          : "left working"
      }
    >
      <div className="flex">
        <i
          className={
            data.status === 1
              ? "fa fa-check-circle"
              : data.status === 0
              ? "fa fa-times-circle"
              : data.status === 2
              ? "fa fa-hourglass-o"
              : data.status === 4
              ? "fa fa-clock-o"
              : "fa fa-info-circle"
          }
        />
        <span style={{ paddingBottom: "2px" }}>{data.text}</span>
      </div>
    </td>
  );
};

const Form2 = ({ data }) => {
  return (
    <form
      method="post"
      action="/"
      onSubmit={(e) => e.preventDefault()}
      style={{ marginTop: data.id !== "golf" ? "35px" : "0" }}
    >
      <table className="approved assigned">
        <thead>
          <tr>
            <th colSpan="3" className="hdg">
              {`${data.name} Guests Status`}
            </th>
          </tr>
          <tr>
            <td className="left">Guest Name</td>
            <td className="center" style={{ width: "21%" }}>
              Status
            </td>
            <td className="center" style={{ width: "21%" }}>
              Registration Complete
            </td>
          </tr>
        </thead>
        {data.guests.length > 0 ? (
          <tbody>
            {data.guests.map((item) => {
              return (
                <tr key={item.guestId}>
                  <td className="left">
                    <span>
                      <Link to={`/dashboard/guest/${item.id}`}>
                        {item.name}
                      </Link>
                    </span>
                  </td>
                  <Td
                    data={{
                      status: item.attention ? 5 : item.status,
                      text: item.text,
                    }}
                  />
                  <td className="center">
                    {item.attention ? (
                      <i
                        className="fa fa-exclamation-circle notice"
                        style={{
                          fontSize: "1.25rem",
                          paddingLeft: "0",
                          paddingTop: "5px",
                        }}
                      />
                    ) : (
                      <i
                        className="fa fa-check-circle success"
                        style={{
                          fontSize: "1.25rem",
                          paddingLeft: "0",
                          paddingTop: "5px",
                        }}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td
                className="center"
                colSpan="4"
                style={{ paddingTop: "15px", paddingBottom: "15px" }}
              >
                <span className="working">-- No guests statuses found --</span>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </form>
  );
};

export default Form2;
